<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaDesde"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model= "filtro.fechaInicioDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="fechaHasta"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model= "filtro.fechaInicioHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <app-cliente
            label="Cliente"
            :nombre="clienteNombre"
            :labelCols="labelCols"
            :lista="clientesList"
            :nullDisabled="false"
            labelOption="Todos los clientes"
            @updated="clienteActualizado">
          </app-cliente>  

          <app-tipo-evento
            label="Tipo de Evento"
            :nombre="tipoEventoNombre"
            :labelCols="labelCols"
            :lista="tiposEventosList"
            :nullDisabled="false"
            labelOption="Todos los tipos"
            @updated="tipoEventoActualizado">
          </app-tipo-evento>  

          <b-form-group
            :label-cols="labelCols"
            horizontal>
            <b-form-checkbox 
                id="sortByDescending"
                v-model="filtro.sortByDescending"
                :value= "Boolean(true)"
                :unchecked-value= "Boolean(false)">
                Ordenar eventos en forma descendente
            </b-form-checkbox>
          </b-form-group>
        </b-form>

        <!-- <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div> -->
      </b-collapse>
      <div slot="footer" v-if="showOpcionesFiltro">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="limpiarFiltro">Limpiar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
// import SearchProveedor from '../proveedores/SearchList.vue';
import Cliente from '../shared/abmSelect.vue';
import TipoEvento from '../shared/abmSelect.vue';
import moment from 'moment';
import tiposEventos from '../../store/modules/tiposEventos';

export default {
  components: {
    // appSearchProveedor: SearchProveedor,
    appCliente: Cliente,
    appTipoEvento: TipoEvento
  },
  props: {
    fechaInicioDesde: {
      type: String,
      default: ''
    },
    fechaInicioHasta: {
      type: String,
      default: ''
    },
    cliente: {
      type: Object,
      default: null
    },
    tipoEvento: {
      type: Object,
      default: null
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        fechaInicioDesde: '',
        fechaInicioHasta: '',
        cliente: null,
        tipoEvento: null,
        sortByDescending: false
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2,

      clientes: [],
      clientesList: [],
      loadingClientes: false,
      tiposEventos: [],
      tiposEventosList: [],
      loadingTiposEventos: false
    }
  },
  created() {
    this.loadingTiposEventos = true;
    this.loadingClientes = true;
    this.getDatosAdicionales();

    this.filtro.fechaInicioDesde = moment.utc(this.fechaInicioDesde).format('YYYY-MM-DD');
    this.filtro.fechaInicioHasta = moment.utc(this.fechaInicioHasta).format('YYYY-MM-DD');
    this.filtro.cliente = this.cliente;
    this.filtro.tipoEvento = this.tipoEvento;
    this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : null;
    },
    'tipoEventoNombre': function() {
      return this.filtro.tipoEvento? this.filtro.tipoEvento.nombre.trim() : null;
    },
  },     
  methods: {
    getDatosAdicionales() {
      this.tiposEventos = [
        {
          id: 1,
          nombre: 'PWA'
        },
        {
          id: 2,
          nombre: 'PORTAL'
        },
        {
          id: 3,
          nombre: 'SORTEO'
        }
      ];
      this.tiposEventosList = [ 'PWA', 'PORTAL', 'SORTEO' ];
      this.loadingTiposEventos = false;
      
      this.$store.dispatch('clientes/getList')
        .then(() => {
          this.clientes = this.$store.getters['clientes/list']
          this.clientesList = this.$store.getters['clientes/selectList']
          this.loadingClientes = false;
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de clientes')))
    },
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
      this.filtro.tipoEvento = null;
    },
    clienteActualizado(clienteNombre) {
      if (!this.loadingClientes) {
        let cliente = null;
        if (clienteNombre) {
          cliente = this.getSelected(this.clientes, clienteNombre);
        }
        this.filtro.cliente = cliente;
      }
    },
    tipoEventoActualizado(tipoEventoNombre) {
      if (!this.loadingTiposEventos) {
        let tipoEvento = null;
        if (tipoEventoNombre) {
          tipoEvento = this.getSelected(this.tiposEventos, tipoEventoNombre);
        }
        this.filtro.tipoEvento = tipoEvento;
      }
    },

    // seleccionarProveedor() {
    //   if (this.filtro.proveedor) {
    //     this.filtro.proveedor = null;
    //   } else {
    //     this.$refs.searchProveedorModal.show();
    //   }
    // },
    // proveedorSeleccionado(proveedor) {
    //   this.filtro.proveedor = proveedor;
    //   this.$refs.searchProveedorModal.hide();
    // },
  },
}
</script>

<style>
</style>
